/**
 * @generated SignedSource<<8946e338d4a9077f4300816b001a1128>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CostRevenueCenterFilter = {
  active?: boolean | null | undefined;
  businessDivision?: string | null | undefined;
  exclude?: ReadonlyArray<string | null | undefined> | null | undefined;
  excludeGoalGroup?: string | null | undefined;
  goalGroup?: string | null | undefined;
  hasGoalGroup?: boolean | null | undefined;
  include?: ReadonlyArray<string | null | undefined> | null | undefined;
  indirectParent?: string | null | undefined;
  isMeResponsible?: boolean | null | undefined;
  nextToLocation?: CoordinatesInputType | null | undefined;
  parent?: string | null | undefined;
  possibleDuplicated?: boolean | null | undefined;
  search?: string | null | undefined;
  tags?: string | null | undefined;
  withAddress?: boolean | null | undefined;
};
export type CoordinatesInputType = {
  label?: string | null | undefined;
  lat: number;
  lng: number;
};
export type CostRevenueCenterSelectFieldRefetchQuery$variables = {
  after?: string | null | undefined;
  filters?: CostRevenueCenterFilter | null | undefined;
  first?: number | null | undefined;
};
export type CostRevenueCenterSelectFieldRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CostRevenueCenterSelectField_query">;
};
export type CostRevenueCenterSelectFieldRefetchQuery = {
  response: CostRevenueCenterSelectFieldRefetchQuery$data;
  variables: CostRevenueCenterSelectFieldRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": {
      "active": true
    },
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CostRevenueCenterSelectFieldRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "CostRevenueCenterSelectField_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CostRevenueCenterSelectFieldRefetchQuery",
    "selections": [
      {
        "alias": "selectCostRevenueCenters",
        "args": (v1/*: any*/),
        "concreteType": "CostRevenueCenterConnection",
        "kind": "LinkedField",
        "name": "costRevenueCenters",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfoExtended",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CostRevenueCenterEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CostRevenueCenter",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "active",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "selectCostRevenueCenters",
        "args": (v1/*: any*/),
        "filters": [
          "filters"
        ],
        "handle": "connection",
        "key": "CostRevenueCenterSelectField_selectCostRevenueCenters",
        "kind": "LinkedHandle",
        "name": "costRevenueCenters"
      }
    ]
  },
  "params": {
    "cacheID": "c2c90d13d957655a17502209ccc30480",
    "id": null,
    "metadata": {},
    "name": "CostRevenueCenterSelectFieldRefetchQuery",
    "operationKind": "query",
    "text": "query CostRevenueCenterSelectFieldRefetchQuery(\n  $after: String\n  $filters: CostRevenueCenterFilter = {active: true}\n  $first: Int = 30\n) {\n  ...CostRevenueCenterSelectField_query_1XoDko\n}\n\nfragment CostRevenueCenterSelectField_query_1XoDko on Query {\n  selectCostRevenueCenters: costRevenueCenters(first: $first, after: $after, filters: $filters) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        name\n        active\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc94b9ec42a0342f62dd4314879a634e";

export default node;
